export const POST_AUTH_REDIRECT_STORAGE_ITEM = 'postAuthRedirect';
